<template>
    <div class="form-group w-100">
        <!-- <div class="col-lg-6"> -->
            <label>เลือกขนาดพัสดุ หรือ กรอกขนาดพัสดุในช่องด้านล่าง ( เซนติเมตร )</label>
            <v-select    
                label="titleBox"
                :options="autoBox"
                v-model="size.boxSize"
                @input="setSelectedboxSize"
                :reduce="titleBox => titleBox.code"
            >
            
            </v-select>
        <!-- </div> -->
    </div>
</template>
<script>
export default {
  name: "autobox",
  props:[
    "width" , "length" , "height" , "keyBox" , "courier_key" , 'size'
  ], 
  data(){
    return{
        defaultSize: [
            { code: 1 , titleBox: 'ขนาดกล่อง: ก/A ความยาว: 14x20x6 ความยาวรวม: 40 ซม.' ,width:'14',length:'20',height:'6' },
            { code: 2 , titleBox: 'ขนาดกล่อง: ข/B ความยาว: 17x25x9 ความยาวรวม: 51 ซม.' ,width:'17',length:'25',height:'9'},
            { code: 3 , titleBox: 'ขนาดกล่อง: ค/C ความยาว: 20x30x11 ความยาวรวม: 61 ซม.' ,width:'20',length:'30',height:'11'},
            { code: 4 , titleBox: 'ขนาดกล่อง: ง/D ความยาว: 22x35x14 ความยาวรวม: 71 ซม.' ,width:'22',length:'35',height:'14'},
            { code: 5 , titleBox: 'ขนาดกล่อง: จ/E ความยาว: 24x40x17 ความยาวรวม: 81 ซม.' ,width:'24',length:'40',height:'17'},
            { code: 6 , titleBox: 'ขนาดกล่อง: ฉ/F ความยาว: 30x45x22 ความยาวรวม: 97 ซม.' ,width:'30',length:'45',height:'22'},
            { code: 7 , titleBox: 'ขนาดกล่อง: Mini ความยาว: 14x20x6 ความยาวรวม: 40 ซม.' ,width:'14',length:'20',height:'6'},
            { code: 8 , titleBox: 'ขนาดกล่อง: S ความยาว: 20x30x10 ความยาวรวม: 60 ซม.' ,width:'20',length:'30',height:'10'},
            { code: 9 , titleBox: 'ขนาดกล่อง: S+ ความยาว: 24x37x14 ความยาวรวม: 75 ซม.' ,width:'24',length:'37',height:'14'},
            { code: 10 , titleBox: 'ขนาดกล่อง: M ความยาว: 27x43x20 ความยาวรวม: 90 ซม.' ,width:'27',length:'43',height:'20'},
            { code: 11 , titleBox: 'ขนาดกล่อง: M+ ความยาว: 35x45x25 ความยาวรวม: 105 ซม.' ,width:'35',length:'45',height:'25'},
            { code: 12 , titleBox: 'ขนาดกล่อง: L ความยาว: 40x50x30 ความยาวรวม: 120 ซม.' ,width:'40',length:'50',height:'30'},
            { code: 13 , titleBox: 'ขนาดกล่อง: Folder ความยาว: 21x30x1 ความยาวรวม: 52 ซม.' ,width:'21',length:'30',height:'1'},
        ],
        SCGSize: [
              { code: 'Envelop' , titleBox: 'Envelope: ซองเอกสาร ขนาดไม่เกิน A3' ,width:'10',length:'1',height:'23' },
              { code: 'PM' , titleBox: 'Polymer Bag (M): (ขนาด 36 x 28 ซม./ความสูงไม่เกิน 10 ซม.)' ,width:'28',length:'36',height:'10'},
              { code: 'PL' , titleBox: 'Polymer Bag (L): (ขนาด 44 x 31 ซม./ความสูงไม่เกิน 10 ซม.)' ,width:'31',length:'44',height:'10'},
              { code: '40' , titleBox: 'S40: ไม่เกิน 40 เซนติเมตร' ,width:'14',length:'13',height:'13'},
              { code: '50' , titleBox: 'S50: ไม่เกิน 50 เซนติเมตร' ,width:'18',length:'16',height:'16'},
              { code: '60' , titleBox: 'S60: ไม่เกิน 60 เซนติเมตร' ,width:'20',length:'20',height:'20'},
              { code: '80' , titleBox: 'S80: ไม่เกิน 80 เซนติเมตร' ,width:'27',length:'26',height:'27'},
              { code: '90' , titleBox: 'S90: ไม่เกิน 90 เซนติเมตร' ,width:'30',length:'30',height:'30'},
              { code: '100' , titleBox: 'S100: ไม่เกิน 100 เซนติเมตร' ,width:'34',length:'33',height:'33'},
              { code: '120' , titleBox: 'S120: ไม่เกิน 120 เซนติเมตร' ,width:'40',length:'40',height:'40'},
              { code: '140' , titleBox: 'S140: ไม่เกิน 140 เซนติเมตร' ,width:'47',length:'46',height:'47'},
              { code: '160' , titleBox: 'S160: ไม่เกิน 160 เซนติเมตร' ,width:'54',length:'53',height:'53'},
              { code: '180' , titleBox: 'S180: ไม่เกิน 180 เซนติเมตร' ,width:'60',length:'60',height:'60'},
              { code: '200' , titleBox: 'S200: ไม่เกิน 200 เซนติเมตร' ,width:'66',length:'67',height:'67'},
              { code: '250' , titleBox: 'S250: ไม่เกิน 250 เซนติเมตร' ,width:'84',length:'83',height:'83'},
        ],
        KRYSSize:[
          {
            code: 'ENVELOP' ,
            titleBox: 'Envelop: ไม่เกิน 32x23 ซม. น้ำหนักไม่เกิน '+(this.$THEME.unitKG ? '0.5 กิโลกรัม' : '500 กรัม' ),
            weight: 500,
            weightKG: 0.5,
            width:'32',
            length:'23',
            height:'1' 
          },
          { 
            code: 'SEALBAGLITE' ,
            titleBox: 'Seal Bag Lite: ไม่เกิน 32x23 ซม. น้ำหนักไม่เกิน '+(this.$THEME.unitKG ? '0.5 กิโลกรัม' : '500 กรัม' ) ,
            weight: 500,
            weightKG: 0.5,
            width:'32',
            length:'24',
            height:'1' 
          },
          { 
            code: 'SEALBAGA|B',
            titleBox: 'Seal Bag (A) / (B): ไม่เกิน 36x28 ซม. น้ำหนักไม่เกิน '+(this.$THEME.unitKG ? '2 กิโลกรัม' : '2,000 กรัม' ),
            weight: 2000,
            weightKG: 2,
            width:'36',
            length:'28',
            height:'1'
          },
          { 
            code: 'SEALBAGC',
            titleBox: 'Seal Bag (C): ไม่เกิน 44x31 ซม.​ น้ำหนักไม่เกิน '+(this.$THEME.unitKG ? '7 กิโลกรัม' : '7,000 กรัม' ),
            weight: 7000,
            weightKG: 7,
            width:'44',
            length:'31',
            height:'1'
          },
          { 
            code: 'MINI',
            titleBox: 'Mini: ไม่เกิน 40 ซม. น้ำหนักไม่เกิน '+(this.$THEME.unitKG ? '2 กิโลกรัม' : '2,000 กรัม' ),
            weight: 2000,
            weightKG: 2,
            width:'14',
            length:'13',
            height:'13'
          },
          { 
            code: 'S',
            titleBox: 'S: ไม่เกิน 60 ซม. น้ำหนักไม่เกิน '+(this.$THEME.unitKG ? '7 กิโลกรัม' : '7,000 กรัม' ),
            weight: 7000,
            weightKG: 7,
            width:'20',
            length:'20',
            height:'20'
          },
          { 
            code: 'SPLUS',
            titleBox: 'S-Plus: ไม่เกิน 75 ซม. น้ำหนักไม่เกิน '+(this.$THEME.unitKG ? '7 กิโลกรัม' : '7,000 กรัม' ),
            weight: 7000,
            weightKG: 7,
            width:'25',
            length:'25',
            height:'25'
          },
          { 
            code: 'M',
            titleBox: 'M: ไม่เกิน 90 ซม. น้ำหนักไม่เกิน '+(this.$THEME.unitKG ? '10 กิโลกรัม' : '10,000 กรัม' ),
            weight: 10000,
            weightKG: 10,
            width:'30',
            length:'30',
            height:'30'
          },
          { 
            code: 'MPLUS',
            titleBox: 'M-Plus: ไม่เกิน 105 ซม. น้ำหนักไม่เกิน '+(this.$THEME.unitKG ? '15 กิโลกรัม' : '15,000 กรัม' ),
            weight: 15000,
            weightKG: 15,
            width:'35',
            length:'35',
            height:'35'
          },
          { 
            code: 'L',
            titleBox: 'L: ไม่เกิน 120 ซม. น้ำหนักไม่เกิน '+(this.$THEME.unitKG ? '15 กิโลกรัม' : '15,000 กรัม' ),
            weight: 15000,
            weightKG: 15,
            width:'40',
            length:'40',
            height:'40'
          },
          { 
            code: 'XL',
            titleBox: 'XL: ไม่เกิน 150 ซม. น้ำหนักไม่เกิน '+(this.$THEME.unitKG ? '20 กิโลกรัม' : '20,000 กรัม' ),
            weight: 20000,
            weightKG: 20,
            width:'50',
            length:'50',
            height:'50'
          },
          { 
            code: 'XXL',
            titleBox: 'XXL: ไม่เกิน 280 ซม. น้ำหนักไม่เกิน '+(this.$THEME.unitKG ? '30 กิโลกรัม' : '30,000 กรัม' ),
            weight: 30000,
            weightKG: 30,
            width:'94',
            length:'93',
            height:'93'
          }
        ]
    }
  },
  watch: { 
    keyBox: function(newVal, oldVal) { 
      if (this.courier_key == 'SCG') {
        this.setSelectedboxSize(newVal)
      }
    }
  },
  methods: {
    setSelectedboxSize(boxSize){
      let size = this.autoBox.find( data => data.code === boxSize );
      if (size) {
        if( size.hasOwnProperty('weight') ){
          this.$emit('update:weight', size.weight);
          if( this.$THEME.unitKG ){
            this.$emit('update:weightKG', size.weightKG);
          }
        }
        this.$emit('update:width', size.width);
        this.$emit('update:length', size.length);
        this.$emit('update:height', size.height);
        this.$emit('update:keyBox', size.code);
        this.$emit('itemPreRate');
      }
    },
  },
  computed:{
    autoBox(){
      let res = this.defaultSize
      if( 'SCG' == this.courier_key){
        res = this.SCGSize
      }else if( 'KRYS' == this.courier_key ){
        res = this.KRYSSize
      }else if( ['SCGC' , 'SCGF'].includes( this.courier_key ) ){
        res = this.SCGSize.filter(function (col) {
          return [ 'Envelop' , 'PM' , 'PL' , 50 , 90, 140 , 160 , 180 , 200
          ].indexOf(col.code) < 0
        }) 
      }
      return res
    }
  }
};
</script>
<style>
</style>